/**
 * Opens the browser's print dialog (save as PDF) for the report page. Chrome ignores window.print() while the page
 * embeds a PDF in an <object> (the dealer's original document), so those are taken out of the page first and put back
 * once the dialog closes; the print runs a tick later, after Chrome has seen them go.
 */
export const printPage = title => {
    const embeds = Array.from(document.querySelectorAll('object[type="application/pdf"]')).map(element => {
        const placeholder = document.createComment('pdf');
        element.replaceWith(placeholder);
        return { element, placeholder };
    });

    setTimeout(() => {
        const originalTitle = document.title;
        document.title = title || originalTitle;
        try {
            window.print();
        } finally {
            document.title = originalTitle;
            embeds.forEach(({ element, placeholder }) => placeholder.replaceWith(element));
        }
    }, 0);
};
